import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

function SetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [linkValid, setLinkValid] = useState(true);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const checkToken = async () => {
      if (!token) { setLinkValid(false); setChecking(false); return; }
      try {
        await axios.post('/api/auth/check-token', { token });
        setLinkValid(true);
      } catch (err) {
        setLinkValid(false);
      }
      setChecking(false);
    };
    checkToken();
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { setError('Passwörter stimmen nicht überein'); return; }
    try {
      await axios.post('/api/auth/set-password', { token, password });
      setMessage('Passwort gesetzt! Du wirst zum Login weitergeleitet...');
      setError('');
      setTimeout(() => navigate('/login'), 2000);
    } catch (err) {
      setError(err.response?.data?.error || 'Fehler beim Setzen des Passworts');
    }
  };

  if (checking) {
    return (
      <div style={styles.container}>
        <div style={styles.box}>
          <img src="/logo.jpg" alt="EliteHomes" style={styles.logo} />
          <p style={{ color: '#888' }}>Link wird geprüft...</p>
        </div>
      </div>
    );
  }

  if (!linkValid) {
    return (
      <div style={styles.container}>
        <div style={styles.box}>
          <img src="/logo.jpg" alt="EliteHomes" style={styles.logo} />
          <h2 style={styles.title}>Link ungültig</h2>
          <div style={styles.expiredBox}>
            <p style={{ fontSize: '14px', color: '#666', marginBottom: '12px' }}>
              Dieser Einladungslink ist <strong>abgelaufen</strong> oder wurde bereits verwendet.
            </p>
            <p style={{ fontSize: '13px', color: '#888' }}>
              Bitte kontaktieren Sie Ihren Administrator, damit ein neuer Link erstellt wird.
            </p>
          </div>
          <button style={styles.button} onClick={() => navigate('/login')}>Zum Login</button>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.box}>
        <img src="/logo.jpg" alt="EliteHomes" style={styles.logo} />
        <h2 style={styles.title}>Passwort setzen</h2>
        {message && <p style={styles.success}>{message}</p>}
        {error && <p style={styles.error}>{error}</p>}
        <form onSubmit={handleSubmit}>
          <input style={styles.input} type="password" placeholder="Neues Passwort"
            value={password} onChange={e => setPassword(e.target.value)} required />
          <p style={styles.pwHint}>Mind. 8 Zeichen, 1 Grossbuchstabe, 1 Zahl</p>
          <input style={styles.input} type="password" placeholder="Passwort bestätigen"
            value={confirm} onChange={e => setConfirm(e.target.value)} required />
          <button style={styles.button} type="submit">Passwort setzen</button>
        </form>
      </div>
    </div>
  );
}

const styles = {
  container: { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' },
  box: { backgroundColor: 'rgba(255,255,255,0.95)', padding: '40px', borderRadius: '8px', boxShadow: '0 2px 20px rgba(0,0,0,0.1)', width: '360px', textAlign: 'center' },
  logo: { width: '150px', height: 'auto', marginBottom: '16px' },
  title: { marginBottom: '24px', color: '#333', fontSize: '20px' },
  input: { width: '100%', padding: '12px', marginBottom: '12px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '14px', boxSizing: 'border-box' },
  button: { width: '100%', padding: '12px', backgroundColor: 'rgb(50,180,170)', color: '#fff', border: 'none', borderRadius: '4px', fontSize: '16px', cursor: 'pointer', marginTop: '8px' },
  error: { color: '#dc3545', textAlign: 'center', marginBottom: '12px', fontSize: '14px' },
  success: { color: '#28a745', textAlign: 'center', marginBottom: '12px', fontSize: '14px' },
  pwHint: { fontSize: '11px', color: '#999', marginTop: '-8px', marginBottom: '12px', textAlign: 'left' },
  expiredBox: { backgroundColor: '#fff3cd', padding: '16px', borderRadius: '6px', marginBottom: '16px', border: '1px solid #ffc107' },
};

export default SetPassword;